import { z } from "zod";

import { MetadataSchema } from "../completions/completions.models";

export const EmbeddingUsageSchema = z.object({
  prompt_tokens: z.number().int(),
  total_tokens: z.number().int(),
});

export type EmbeddingUsage = z.infer<typeof EmbeddingUsageSchema>;

/**
 * OpenAI-compatible embedding response payload
 * Based on https://platform.openai.com/docs/api-reference/embeddings/create
 */
export const EmbeddingResponsePayloadSchema = z.object({
  id: z.string(),
  object: z.literal("list"),
  data: z.array(
    z.object({
      object: z.literal("embedding"),
      embedding: z.union([z.array(z.number()), z.string()]), // Can be float array or base64 string
      index: z.number().int(),
    }),
  ),
  model: z.string(),
  usage: EmbeddingUsageSchema.optional(),
  metadata: MetadataSchema.optional(),
});

export type EmbeddingResponsePayload = z.infer<
  typeof EmbeddingResponsePayloadSchema
>;
